module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg width=2048 height=1792 viewBox=\"0 0 2048 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M2020 11q28 20 28 53v1408q0 20-11 36t-29 23l-640 256q-24 11-48 0l-616-246-616 246q-10 5-24 5-19 0-36-11-28-20-28-53v-1408q0-20 11-36t29-23l640-256q24-11 48 0l616 246 616-246q32-13 60 6zm-1284 135v1270l576 230v-1270zm-608 217v1270l544-217v-1270zm1792 1066v-1270l-544 217v1270z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/mini-apps/app-switcher/icons/softproof.svg
// module id = 215
// module chunks = 0